import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/styles/app.scss'
import '@/plugin/axios'
import filter from '@/utils/filter'
import { mixin as clickaway } from 'vue-clickaway'

Vue.config.productionTip = false

Vue.mixin(clickaway)

new Vue({
	router,
	store,
	filter,
	render: h => h(App)
}).$mount('#app')
